import { FormattedMessage } from 'react-intl';

import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';

import UserDateFormat from '../../../../../../components/user-date-timezone-format';
import { messages } from '../../../messages';

import type { PickListGridItem } from '../pick-list-grid';

type CreatedCellProps = {
  row: { original: PickListGridItem };
};

const CreatedCell = ({ row }: CreatedCellProps) => {
  const { shared, createDate } = row.original;
  if (shared || !createDate) {
    return null;
  }
  return <UserDateFormat dateTime={createDate} />;
};

export const createCreatedColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'createDate',
  Header: <FormattedMessage {...messages.gridColCreated} />,
  Cell: CreatedCell,
  width: 1.25,
});
